<template>
    <svg
        width="306"
        height="172"
        viewBox="0 0 306 172"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <!-- eslint-disable vue/max-attributes-per-line -->
        <path d="M66.5 172 306 126v46H66.5Z" fill="#fff"/>
        <path d="M66.5 172 0 2V0h306v59.7283L66.5 172Z" fill="#CACED3"/>
        <path d="M306 137.5 66.5 172 306 92v45.5Z" fill="#F4F5F6"/>
        <path d="M66.5 172 306 98V31L66.5 172Z" fill="#E3E5E8"/>
        <path d="M66.5 172H0V0l66.5 172Z" fill="#AEB4BC"/>
        <!-- eslint-disable vue/max-attributes-per-line -->
    </svg>
</template>
